var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useTagContext } from '@data/tag/tagContext';
import { getTagLongName } from '@data/tag/tagUtil';
import { useSheetRowPath, useSheetRowsById } from '../sheetRow/sheetRowHooks';
function truncateTitle(title) {
    var MAX_LENGTH = 30;
    var newtitle = title;
    if (title.length > MAX_LENGTH) {
        newtitle = newtitle.substring(0, MAX_LENGTH);
    }
    if (newtitle.length !== title.length) {
        newtitle = newtitle + '...';
    }
    return newtitle;
}
export function useBreadcrumbs() {
    var e_1, _a;
    var path = useSheetRowPath();
    var sheetRowById = useSheetRowsById();
    var tagData = useTagContext().tagData;
    var breadcrumbItems = [];
    try {
        for (var _b = __values(path.segments), _c = _b.next(); !_c.done; _c = _b.next()) {
            var segment = _c.value;
            if (segment.tagId) {
                var tag = tagData.tagById[segment.tagId];
                if (tag) {
                    breadcrumbItems.push({
                        path: segment.fullPath,
                        label: truncateTitle(getTagLongName(tag)),
                    });
                }
            }
            else {
                var sheetRow = sheetRowById[segment.sheetRowId];
                if (sheetRow) {
                    breadcrumbItems.push({
                        path: segment.fullPath,
                        label: truncateTitle(sheetRow.name),
                    });
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return breadcrumbItems;
}
